import axios from "axios";
import { URL } from "./MainAPILink";
import { notificationHandler } from "reducers/notificationSlice";
import CatchMessage from "./catchMessage";
import { notify } from "App";

// Backend now sends the list as { data: { list: [ ... ] } }.
const normalizeNewsList = (d) => {
  if (Array.isArray(d)) return d;
  if (Array.isArray(d?.list)) return d.list;
  if (Array.isArray(d?.data?.list)) return d.data.list;
  if (Array.isArray(d?.data)) return d.data;
  return [];
};

const normalizeNewsItem = (d) => {
  if (Array.isArray(d)) return d[0] ?? null;
  if (Array.isArray(d?.list)) return d.list[0] ?? null;
  return d;
};

const GetNewsAPI = async (access_token, dispatch) => {
  try {
    const response = await axios.get(URL + "news", {
      headers: {
        Authorization: `Bearer ${access_token}`,
      },
    });
    return normalizeNewsList(response.data.data);
  } catch (err) {
    CatchMessage(err, dispatch);

    return null;
  }
};

const DeleteNewsAPI = async (data, access_token, dispatch) => {
  try {
    const response = await axios.delete(URL + "news", {
      params: data, // Use 'data' instead of 'body' for DELETE requests
      headers: {
        Authorization: `Bearer ${access_token}`,
      },
    });
    // notificationHandler("BLog Deleted !", "success", dispatch);
    notify("News Deleted !", "success");

    return response.data;
  } catch (err) {
    CatchMessage(err, dispatch);
    notify(err?.response?.message, "error");

    return null;
  }
};

const AddNewsAPI = async (data, access_token, dispatch) => {
  try {
    const response = await axios.post(URL + "news", data, {
      headers: {
        Authorization: `Bearer ${access_token}`,
      },
    });
    // notificationHandler("new blog added", "success", dispatch);

    return response.data.data;
  } catch (err) {
    CatchMessage(err, dispatch);
    notify(err?.response?.message, "error");

    return null;
  }
};

const GetNewsDetails = async (news_id, access_token, dispatch) => {
  try {
    const response = await axios.get(URL + `news/?news_id=${news_id}`, {
      headers: {
        Authorization: `Bearer ${access_token}`,
      },
    });
    return normalizeNewsItem(response.data.data);
  } catch (err) {
    CatchMessage(err, dispatch);

    return null;
  }
};

const EditNewsAPI = async (data, access_token, dispatch) => {
  try {
    const response = await axios.put(URL + "news", data, {
      headers: {
        Authorization: `Bearer ${access_token}`,
      },
    });
    if (response.data.status === 200) {
      return true;
    }
    return false;
  } catch (err) {
    notify(err?.response?.message, "error");

    CatchMessage(err, dispatch);
    return null;
  }
};

export { GetNewsAPI, DeleteNewsAPI, AddNewsAPI, GetNewsDetails, EditNewsAPI };
